export default "__VITE_ASSET__BdR2vm4A__"